import React, { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { capitalizeWords } from "../icons/ApplicationColor";
const ThirdBar = ({ menuItems }) => {
  let mapItems;

  if (typeof menuItems === "function") {
    mapItems = menuItems();
  } else {
    mapItems = menuItems;
  }

  const scrollWrapperRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const checkOverflow = () => {
    if (scrollWrapperRef.current) {
      const { scrollWidth, clientWidth } = scrollWrapperRef.current;
      setIsOverflowing(scrollWidth > clientWidth);
    }
  };

  const scrollLeft = () => {
    scrollWrapperRef.current.scrollBy({ left: -150, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollWrapperRef.current.scrollBy({ left: 150, behavior: "smooth" });
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);
  return (
    <div>
      <div className="third-navbar-container-old-white-test">
        {isOverflowing && (
          <button className="scroll-button-white left" onClick={scrollLeft}>
            <LeftOutlined />
          </button>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
          }}
          className="navbar-scroll-wrapper-white"
          ref={scrollWrapperRef}
        >
          <div className="third-navbar-links-white">
            {mapItems.map((item, index) => (
              <NavLink
                key={index}
                to={`${item.path}`}
                className={({ isActive }) =>
                  isActive && item?.not_active !== true
                    ? "third-three-nav-old third-active-three-nav-old"
                    : "third-three-nav-old"
                }
              >
                {item.icon}
                {capitalizeWords(item.name)}
              </NavLink>
            ))}
          </div>
        </div>
        {isOverflowing && (
          <button className="scroll-button-white right" onClick={scrollRight}>
            <RightOutlined />
          </button>
        )}
      </div>
    </div>
  );
};

export default ThirdBar;
